import {
  CommoditiesApi,
  CommodityDto,
  CreateCommodityCommand,
  CreateCommodityWithCodeDto,
  UpdateCommodityCommand,
} from '@billing/app/api'
import { createApiClient } from '@billing/app/http-client'
import commodityService from '@billing/services/CommodityService'
import { makeObservable, observable, runInAction } from 'mobx'
import { BaseEntityStore } from './base/BaseEntityStore'

export class CommodityStore extends BaseEntityStore<CommodityDto> {
  fecthedAll = false

  constructor() {
    super()
    makeObservable(this, { fecthedAll: observable })
  }

  loadAll = async () => {
    const { data } = await createApiClient(CommoditiesApi).get()
    this.updateStoreItems(data)

    runInAction(() => {
      this.fecthedAll = true
    })
  }

  async loadAllWhenNotFetched() {
    if (this.fecthedAll) return
    await this.loadAll()
  }

  private findCommodityById(items: CommodityDto[], id: number): CommodityDto | undefined {
    for (const item of items) {
      if (item.id === id) {
        return item
      }

      if (!item.childCommodities?.length) {
        continue
      }

      const found = this.findCommodityById(item.childCommodities, id)
      if (found) {
        return found
      }
    }
    return undefined
  }

  async loadById(id: number) {
    const existingCommodity = this.findCommodityById(this.items, id)

    if (!existingCommodity) {
      const { data } = await createApiClient(CommoditiesApi).get_1(id)
      this.updateStoreItem(data as CommodityDto, id)
    }
  }

  async updateIsActiveStatus(commodity: CommodityDto, isActive: boolean) {
    await commodityService.setIsActiveStatus(commodity.id, isActive)
  }

  async add(commodity: CreateCommodityCommand) {
    await commodityService.addCommodity(commodity)
  }

  async update(commodity: UpdateCommodityCommand) {
    await commodityService.updateCommodity(commodity)
  }

  async delete(id: number) {
    await createApiClient(CommoditiesApi)._delete(id)
  }

  async createCommoditiesFromCsv(data: CreateCommodityWithCodeDto[]) {
    await commodityService.createCommoditiesFromCsv({ commodities: data })
  }
}
